angular.module("ainapp")
    .controller("bulkPrintController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Bulk Print";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {

                var startdate = new Date(new Date().getFullYear(), 0, 1);

                $scope.filter = {
                    VoucherFrom: "",
                    VoucherTo: "",
                }

                $scope.load = false;
                $scope.ViewVal = 1;
                $scope.selectedVoucherName = "Material Request";
                $scope.SelectedVoucher = "Material Request";

            }
            $scope.Init();

            $scope.switchTab = function (id, type, voucher) {
                $scope.selectedVoucherName = voucher;
                $scope.ViewVal = id;
                $scope.SelectedVoucher = type;
            };

            $scope.printBulk = function () {

                console.log($scope.SelectedVoucher);

                if ($scope.SelectedVoucher == "Sales Invoice") {

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkSalesInvoice($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })

                }
                else if ($scope.SelectedVoucher == "Material Request") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkMaterialRequest($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Purchase Request") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkPurchaseRequest($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Purchase Enquiry") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkPurchaseEnquiry($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Purchase Quotation") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkPurchaseQuotation($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Purchase Order") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkPurchaseOrder($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Goods Received") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkGoodsReceived($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Purchase Invoice") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkPurchaseInvoice($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Direct Purchase Invoice") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkDirPurchaseInvoice($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Individual Purchase Invoice") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkIndPurchaseInvoice($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Import Purchase Invoice") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkImpPurchaseInvoice($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Export Purchase Invoice") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkExpPurchaseInvoice($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Purchase Return") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkPurchaseReturn($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Sales Enquiry") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkSalesEnquiry($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Sales Enquiry 2") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkSalesEnquiry2($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.PrintBulkSalesEnquiry3 == "Sales Enquiry 3") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkSalesInvoice($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.PrintBulkSalesEnquiry4 == "Sales Enquiry 4") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkSalesInvoice($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.PrintBulkSalesQuotation == "Sales Quotation") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkSalesInvoice($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Sales Quotation 2") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkSalesQuotation2($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Sales Quotation 3") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkSalesQuotation3($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Sales Quotation 4") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkSalesQuotation4($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Sales Order") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkSalesOrder($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Sales Order 2") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkSalesOrder2($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Sales Order 3") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkSalesOrder3($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Sales Order 4") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkSalesOrder4($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Delivery Note") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkDeliveryNote($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Delivery Note 2") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkDeliveryNote2($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Delivery Note 3") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkDeliveryNote3($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Delivery Note 4") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkDeliveryNote4($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Packing List") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkPackingList($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Sales Invoice 2") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkSalesInvoice2($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Sales Invoice 3") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkSalesInvoice3($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Sales Invoice 4") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkSalesInvoice4($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Direct Sales Invoice") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkDirSalesInvoice($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Individual Sales Invoice") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkIndSalesInvoice($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Export Sales Invoice") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkExpSalesInvoice($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Proforma Invoice") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkProSalesInvoice($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Sales Return") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkSalesReturn($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
                else if ($scope.SelectedVoucher == "Credit Note SR") {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.PrintBulkCreditNoteSR($scope.filter).then(function (response) {
                        if (response.data != null) {
                            if (response.data == "NoFrom") {
                                toastr.error("From Invoice Not Found");
                            } else if (response.data == "NoTo") {
                                toastr.error("To Invoice Not Found");
                            } else {
                                $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }



            }




        }])
